import { useEffect, useState } from "react";

const DURATION = 17 * 60 + 34; // 00:17:34
const START = Date.now();

function compute() {
  const elapsed = Math.floor((Date.now() - START) / 1000);
  const remaining = DURATION - (elapsed % DURATION);
  const spots = Math.max(3, 9 - Math.floor(elapsed / 45));
  return { remaining, spots };
}

export function useOfferClock() {
  const [state, setState] = useState(compute);
  useEffect(() => {
    const id = window.setInterval(() => setState(compute()), 1000);
    return () => window.clearInterval(id);
  }, []);
  const h = Math.floor(state.remaining / 3600);
  const m = Math.floor((state.remaining % 3600) / 60);
  const s = state.remaining % 60;
  return {
    hours: String(h).padStart(2, "0"),
    minutes: String(m).padStart(2, "0"),
    seconds: String(s).padStart(2, "0"),
    spots: state.spots,
    totalSpots: 100,
  };
}
